// src/components/itinerary/DayPanel.tsx
// src/components/itinerary/DayPanel.tsx
// Update the DayPanel component to have better layout stability

import React from 'react';
import { Paper, Typography, Box } from '@mui/material';
import { format } from 'date-fns';
import { Droppable } from 'react-beautiful-dnd';
import { ItineraryDay, Activity } from '../../contexts/ItineraryContext';
import TimeSlotItem from './TimeSlotItem';

interface DayPanelProps {
  day: ItineraryDay;
  dayIndex: number;
  getActivityIcon: (type: string) => JSX.Element;
  findActivityById: (id: string) => Activity | undefined;
  removeActivityFromSlot: (dayIndex: number, slotIndex: number) => void;
}

const DayPanel: React.FC<DayPanelProps> = ({
  day,
  dayIndex,
  getActivityIcon,
  findActivityById,
  removeActivityFromSlot
}) => {
  return (
    <Paper 
      variant="outlined" 
      sx={{ 
        p: 2, 
        mb: 3,
        height: '100%', // Fill the parent height
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <Typography 
        variant="subtitle1" 
        gutterBottom 
        fontWeight="bold"
        sx={{ 
          position: 'sticky', // Keep the date visible when scrolling
          top: 0,
          bgcolor: 'background.paper',
          zIndex: 1,
          py: 1
        }}
      >
        {format(day.date, 'EEEE, MMMM d, yyyy')}
      </Typography>
      
      <Box sx={{ 
        mt: 2,
        flex: 1, // Take remaining space
        overflow: 'auto', // Enable scrolling if needed
        minHeight: 0 // Important for flex child to scroll
      }}>
        {day.slots.map((slot, slotIndex) => (
          <Droppable 
            key={slot.id} 
            droppableId={`day-${dayIndex}-${slotIndex}`}
          >
            {(provided, snapshot) => (
              <div
                ref={provided.innerRef}
                {...provided.droppableProps}
                style={{ 
                  marginBottom: '8px',
                  transition: 'transform 0.2s ease',
                  transform: snapshot.isDraggingOver ? 'scale(1.01)' : 'scale(1)'
                }}
              >
                <TimeSlotItem
                  slot={slot}
                  activity={slot.activityId ? findActivityById(slot.activityId) : undefined}
                  isDraggingOver={snapshot.isDraggingOver}
                  getActivityIcon={getActivityIcon}
                  onRemoveActivity={() => removeActivityFromSlot(dayIndex, slotIndex)}
                />
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        ))}
      </Box>
    </Paper>
  );
};

export default DayPanel;